import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

export default {
    async fetchReceiptLogs({ commit }, data) {
        let variables = {};
        if (data) {
            variables = { limit: data.limit, offset: data.offset };
            if (data.search) {
                variables.search = data.search;
            }
            if (data.excludeAvailableWhenZero !== undefined) {
                variables.excludeAvailableWhenZero =
                    data.excludeAvailableWhenZero;
            }
        }
        const response = await fetch.query({
            query: Query.receiptLogs,
            variables,
        });
        commit("setTotalCount", response.data.receiptLogs.total);

        if (!data) {
            commit("setReceiptLogs", response.data.receiptLogs.receiptLogs);
        } else if (data.offset === 0) {
            commit("setReceiptLogs", response.data.receiptLogs.receiptLogs);
        } else {
            // when we are paging the data, we want to update, not set
            commit("updateReceiptLogs", response.data.receiptLogs.receiptLogs);
        }
        return {
            pageInfo: response.data.receiptLogs.pageInfo,
            returned: response.data.receiptLogs.returned,
        };
    },
    async fetchReceiptLogsCalculateCost(context, data) {
        const response = await fetch.query({
            query: Query.receiptLogsCalculateCost,
            variables: {
                ids: data,
            },
        });
        return response.data.receiptLogsWithIds;
    },
    clearSelectedReceiptLog({ commit }) {
        commit("setSelectedReceiptLog", {});
    },
    setReceiptLogsPerPage({ commit }, data) {
        commit("setReceiptLogsPerPage", data);
    },
};
